import moment from 'moment';

export const dateDDMMYYYYtoISO = (value: any) => moment(value, 'DD/MM/YYYY').format('YYYY-MM-DD');

export const dateISOtoDDMMYYYY = (value: any) => moment(value).format('DD/MM/YYYY');

export const dateISOtoDDMMMYYYY = (value: any) => moment(value).format('DD-MMM-YYYY');

export const dateISOtoDMMMYYYY = (value: any) => moment(value).format('D MMM YYYY');

export const dateISOtoTime = (value: any) => moment(value).format('LT');

export const getDuration = (from: any, to: any) => moment.duration(moment(from).diff(moment(to))).toISOString();

export const dateISOtoAge = (from: any, to: any) => moment(to || undefined).diff(moment(from), 'years');

export const extractISODate = (value: any) => {
  const isoDateRegex = /^\d{4}-\d{2}-\d{2}/;
  const result = isoDateRegex.exec(value);
  return result && result[0];
};

export const checkPastDaysFromToday = (date?: string) => {
  if (!date) return undefined;
  const oneDayTime = 1000 * 60 * 60 * 24;
  const pastDate = new Date(date).getTime();
  const currentDate = new Date().getTime();

  const differenceInTime = currentDate - pastDate;
  const differenceInDays = differenceInTime / oneDayTime;
  return Math.round(differenceInDays);
};
